const getAccountNameWithNumber = (account) => {
  if (!account.accountName) {
    return `${account.accountId} - ${account.accountId.slice(-4)}`
  }

  return `${account.accountName} - ${account.accountId}`
}

export default getAccountNameWithNumber
